import React, { useState } from 'react';
import {
  IconMail,
  IconPhoneCall,
  IconClock,
  IconMapPin,
} from '@tabler/icons-react';

// Import your social media PNGs here:
import twitterIcon from '../../assets/images/x.png';
import linkedinIcon from '../../assets/images/linkedin.png';
import facebookIcon from '../../assets/images/facebook.png';
import instagramIcon from '../../assets/images/instagram.png';
import pinterestIcon from '../../assets/images/pinterest.png';
import googlePlayBadge from '../../assets/images/google-play-badge.png';
import appStoreBadge from '../../assets/images/app-store-badge.png';
import subscribeBg from '../../assets/images/subscribe-bg.jpg';
import Logo from '../../assets/images/paqtory.png';
import { NavLink } from 'react-router-dom';
import userNewsLetterApi from '../../redux/slices/usersSlice';
import { useDispatch } from 'react-redux';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const dispatch = useDispatch()

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();



    if (!email) {
      setMessage('Please enter a valid email address.');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage('Please enter a valid email address.');
      return;
    }


    setIsSubmitting(true);
    setMessage('');


    try {
      dispatch(
        userNewsLetterApi(email)
      )
      setMessage('Thank you for subscribing! Check your email for your £10 voucher.');
      setEmail('');
    } catch (error) {
      setMessage('Something went wrong. Please try again.');
    }

  };

  return (
    <footer className="bg-[#0B0C52] text-white pt-10 pb-5">
      <div
        className="relative bg-cover bg-center py-10 px-4 text-white"
        style={{ backgroundImage: `url(${subscribeBg})` }}
      >
        {/* Optional dark overlay if using a background image */}
        <div className="absolute inset-0 bg-black/40"></div>

        <div className="relative max-w-screen-xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          {/* LEFT COLUMN: Headline, Description, Email Form, Disclaimer */}
          <div className="md:w-1/2 space-y-4">
            <h2 className="text-2xl md:text-3xl font-bold">
              Stay Updated &amp; Get £10 Off!
            </h2>
            <p className="text-sm">
              Sign up for exclusive updates on new customizable products,
              special offers, and more. Plus, enjoy a £10 voucher on your
              first order over £50!
            </p>

            {/* Subscription Form */}
            <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row items-stretch">
              <input
                type="email"
                placeholder="snap@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
                className="text-black rounded-t sm:rounded-l sm:rounded-t-none px-3 py-2 w-full sm:w-auto focus:outline-none disabled:opacity-50"
                required
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-[#FFD100] text-black font-semibold px-4 py-2 rounded-b sm:rounded-r sm:rounded-b-none hover:bg-[#FFCA00] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>

            {/* Status Message */}
            {message && (
              <p className={`text-sm ${message.includes('Thank you') ? 'text-green-300' : 'text-red-300'}`}>
                {message}
              </p>
            )}

            {/* Disclaimer text */}
            <p className="text-xs">
              By subscribing you agree to our{' '}
              <a href="/terms-and-conditions" className="underline">
                Terms &amp; Conditions
              </a>{' '}
              and{' '}
              <a href="/privacy-policy" className="underline">
                Privacy &amp; Cookies Policy
              </a>.
            </p>
          </div>

          {/* RIGHT COLUMN: Contact Info & Store Badges */}
          <div className="md:w-1/2 text-left md:text-right space-y-4">
            <p className="font-bold text-lg">Need help?</p>
            <p className="text-md">+1 (860) 533-7110</p>
            <div className="flex flex-row md:justify-end gap-4 mt-4">
              <img
                src={googlePlayBadge}
                alt="Get it on Google Play"
                className="w-32 h-auto object-contain"
              />
              <img
                src={appStoreBadge}
                alt="Download on the App Store"
                className="w-32 h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Top Row */}
      <div className="flex flex-wrap justify-between max-w-[1200px] mx-auto px-4 gap-6">
        {/* Column 1: Logo & Tagline */}
        <div className="flex flex-col gap-2 mb-6 min-w-[180px] basis-[220px]">
          {/* Circular Container */}
          <div className="w-[60px] h-[60px] rounded-full bg-white mb-2 overflow-hidden flex items-center justify-center">
            <img src={Logo} alt="Logo" className="w-full h-full object-contain" />
          </div>


          {/* <p className="font-bold text-base">Logo</p> */}
          <p className="text-sm mt-1">Custom Creations, Made for You!</p>
        </div>

        {/* Column 2: Quick Links */}
        <div className="flex flex-col gap-2 mb-6 min-w-[180px] basis-[220px]">
          <p className="font-bold text-base mb-2">Quick Links</p>
          <NavLink
            to="/"
            className="text-sm cursor-pointer hover:underline"
          >
            Home
          </NavLink>
          <NavLink
            to="/product-categories"
            className="text-sm cursor-pointer hover:underline"
          >
            Categories
          </NavLink>
          <NavLink
            to="/faq"
            className="text-sm cursor-pointer hover:underline"
          >
            FAQ
          </NavLink>
          <NavLink
            to="/aboutus"
            className="text-sm cursor-pointer hover:underline"
          >
            About Us
          </NavLink>
          <NavLink
            to="/contactus"
            className="text-sm cursor-pointer hover:underline"
          >
            Contact Us
          </NavLink>
        </div>

        <div className="flex flex-col gap-2 mb-6 min-w-[180px] basis-[220px]">
          <p className="font-bold text-base mb-2">Contact Us</p>
          <div className="flex items-center gap-2 text-sm">
            <IconMail size={16} />
            <p>salihshafi2244@gmail.com</p>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <IconPhoneCall size={16} />
            <p>+917994063319</p>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <IconClock size={16} />
            <p>We are available 24/7 to assist you.</p>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <IconMapPin size={16} />
            <p>Visit us at Pallath Building, Mappattukara, Palakkad (Dist), Kerala, India</p>
          </div>
        </div>

        {/* Column 4: Follow Us */}
        <div className="flex flex-col gap-2 mb-6 min-w-[180px] basis-[220px]">
          <p className="font-bold text-base mb-2">Follow Us</p>
          <div className="flex gap-3 mt-2">
            {/* Replace Tabler icons with your own PNG images */}
            {/* <img
              src={twitterIcon}
              alt="Twitter"
              className="cursor-pointer w-5 h-5 object-contain"
            /> */}
            {/* <img
              src={linkedinIcon}
              alt="LinkedIn"
              className="cursor-pointer w-5 h-5 object-contain"
            /> */}
            {/* <img
              src={facebookIcon}
              alt="Facebook"
              className="cursor-pointer w-5 h-5 object-contain"
            /> */}
            <a
              href="https://www.instagram.com/paqtory?igsh=MWQ5MTlsOHhicDg5cQ=="
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={instagramIcon}
                alt="Instagram"
                className="cursor-pointer w-5 h-5 object-contain"
              />
            </a>
            {/* <img
              src={pinterestIcon}
              alt="Pinterest"
              className="cursor-pointer w-5 h-5 object-contain"
            /> */}
          </div>
        </div>
      </div>

      {/* Divider */}
      <hr className="border-t border-gray-200 opacity-30 my-2 max-w-[1200px] mx-auto" />

      {/* Bottom Row */}
      <div className="max-w-[1200px] mx-auto px-4 text-center text-[13px]">
        <p>
          © 2025 paqtory. All Rights Reserved. Prices and availability are subject to change.
        </p>
      </div>
    </footer>
  );
}